import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-cancelar-boleto-dialog',
  templateUrl: './cancelar-boleto-dialog.html',
  styleUrls: ['./cancelar-boleto-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class CancelarBoletoDialog {
  constructor(
    private dialogRef: MatDialogRef<CancelarBoletoDialog>,
  ) { }

  confirmarCancelamento() {
    this.dialogRef.close(true);
  }

  cancelar() {
    this.dialogRef.close();
  }
}
